var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path8, _path9, _path10, _path11, _path12, _circle, _g, _circle2, _g2, _circle3, _circle4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhereAmIButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 76,
    viewBox: "0 0 52 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1149 54.5044C42.1149 54.5044 43.7296 59.1516 45.4318 61.3176C47.134 63.4837 48.1941 60.121 48.1941 60.121C48.1941 60.121 49.5755 56.069 49.023 51.2801C48.4704 46.4912 46.3011 40.3545 46.3011 40.3545L42.1149 54.5044Z",
    fill: "url(#paint0_linear_10517_2866)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1151 54.5044C42.1151 54.5044 43.7299 59.1516 45.4321 61.3176C47.1343 63.4837 48.1944 60.121 48.1944 60.121C48.1944 60.121 49.5758 56.069 49.0232 51.2801C48.4706 46.4912 46.3014 40.3545 46.3014 40.3545L42.1151 54.5044Z",
    fill: "url(#paint1_linear_10517_2866)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.201 54.5044C10.201 54.5044 8.58628 59.1516 6.88408 61.3176C5.18189 63.4837 4.1218 60.121 4.1218 60.121C4.1218 60.121 2.74038 56.069 3.29295 51.2801C3.84551 46.4912 6.01479 40.3545 6.01479 40.3545L10.201 54.5044Z",
    fill: "url(#paint2_linear_10517_2866)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3617 13.253C12.5497 10.718 13.0776 9.66657 13.2959 8.4513L37.7818 10.5405C38.0944 11.6226 37.9175 12.8738 37.79 13.3641C37.0244 16.0894 34.4864 16.7776 33.3131 16.7811L18.1501 16.632C15.3027 16.4546 13.7385 14.2447 13.3617 13.253Z",
    fill: "url(#paint3_linear_10517_2866)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6327 5.04605C14.1152 5.15208 13.072 8.22118 13.1152 9.74247C13.129 14.4769 17.7991 15.389 20.1324 15.2532L32.1618 15.2181C36.9586 15.3588 38.0214 12.8415 37.9532 11.5652C37.9116 7.91395 34.7548 6.88139 33.1817 6.82152C32.3919 1.28483 27.9404 0.170951 25.8134 0.306098C20.2435 0.32237 18.7055 3.47285 18.6327 5.04605Z",
    fill: "url(#paint4_linear_10517_2866)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9864 15.88C24.9864 15.88 25.0588 15.6909 25.5559 15.6749C26.053 15.6589 26.1387 15.8587 26.1387 15.8587L26.3723 20.1582L25.2285 20.132L24.9864 15.88Z",
    fill: "url(#paint5_linear_10517_2866)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50555 35.6286C9.04773 22.0611 20.2129 18.8234 25.4777 18.9005C34.6676 18.5316 43.0769 24.0117 45.6174 34.1194C48.4939 45.564 44.6483 56.5588 41.2008 62.3259C36.0894 70.8764 32.111 72.2926 30.5327 72.009C28.4494 71.6347 27.8508 66.987 27.6849 65.3715C26.3784 66.1142 23.8057 65.804 23.0325 65.513L22.7262 67.2175C21.75 72.5624 18.8424 71.9461 17.6873 71C4.1629 59.9224 5.09071 41.3265 6.50555 35.6286Z",
    fill: "url(#paint6_linear_10517_2866)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6034,
    cy: 30.1752,
    rx: 5.36948,
    ry: 7.22673,
    transform: "rotate(10.1866 18.6034 30.1752)",
    fill: "url(#paint7_linear_10517_2866)",
    fillOpacity: 0.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0804,
    cy: 30.7459,
    rx: 5.36948,
    ry: 7.22673,
    transform: "rotate(-9.89189 33.0804 30.7459)",
    fill: "url(#paint8_linear_10517_2866)",
    fillOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6546,
    cy: 30.726,
    rx: 4.70749,
    ry: 5.88436,
    transform: "rotate(10.1866 18.6546 30.726)",
    fill: "url(#paint9_linear_10517_2866)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0411,
    cy: 31.1923,
    rx: 4.70749,
    ry: 5.88436,
    transform: "rotate(-7.24141 33.0411 31.1923)",
    fill: "url(#paint10_linear_10517_2866)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5623,
    cy: 30.6648,
    rx: 2.94218,
    ry: 4.11905,
    transform: "rotate(10.1866 19.5623 30.6648)",
    fill: "url(#paint11_linear_10517_2866)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5623,
    cy: 30.6648,
    rx: 2.94218,
    ry: 4.11905,
    transform: "rotate(10.1866 19.5623 30.6648)",
    fill: "url(#paint12_linear_10517_2866)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.8553,
    cy: 30.9792,
    rx: 2.94218,
    ry: 4.11905,
    transform: "rotate(-6.22363 31.8553 30.9792)",
    fill: "url(#paint13_linear_10517_2866)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2587,
    cy: 29.6392,
    rx: 0.966675,
    ry: 1.35335,
    transform: "rotate(10.1866 20.2587 29.6392)",
    fill: "#FBFFFF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6571,
    cy: 30.3125,
    rx: 0.966675,
    ry: 1.35335,
    transform: "rotate(-16.909 31.6571 30.3125)",
    fill: "#FBFFFF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6283,
    cy: 37.2774,
    rx: 2.05953,
    ry: 1.26881,
    transform: "rotate(10.1866 13.6283 37.2774)",
    fill: "#F77935"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.4362,
    cy: 37.8722,
    rx: 2.05953,
    ry: 1.26881,
    transform: "rotate(-0.431125 37.4362 37.8722)",
    fill: "#F77935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 38.0633L19.9099 38.4723C21.5979 42.1532 24.2849 42.0856 25.3547 42.0434C27.4621 41.9887 29.7323 39.6684 30.6667 38.0633Z",
    fill: "url(#paint14_linear_10517_2866)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8707 39.1959C28.8433 38.5105 27.6984 38.2591 26.877 38.2073L26.0162 38.24C23.4788 38.6546 22.2292 39.848 21.6865 40.9246C23.106 42.1137 24.6158 42.0725 25.3545 42.0433C26.9977 42.0007 28.74 40.5804 29.8707 39.1959Z",
    fill: "#032E58"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1213 38.125L21.1882 38.4172C22.0141 39.2798 24.5154 40.0071 26.3459 38.7997C26.4205 38.7505 26.5098 38.7327 26.5862 38.753C27.9351 39.1121 28.8721 38.4625 29.1213 38.125Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5119 24.8383L30.5209 24.2195C30.3752 24.2015 30.285 24.0508 30.3544 23.9215C31.0003 22.7182 32.5427 22.4772 33.2516 22.5852C34.6941 22.6993 35.7016 24.0327 35.7138 24.6866C35.7157 24.7903 35.6149 24.8511 35.5119 24.8383Z",
    fill: "url(#paint15_linear_10517_2866)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2415 24.5038L21.2437 23.9825C21.3897 23.9673 21.4828 23.8184 21.4159 23.6878C20.7936 22.4722 19.2562 22.2011 18.5453 22.2952C17.1009 22.3812 16.0676 23.6947 16.0426 24.3482C16.0386 24.4519 16.1383 24.5145 16.2415 24.5038Z",
    fill: "url(#paint16_linear_10517_2866)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6718,
    cy: 54.4551,
    r: 7.31214,
    transform: "rotate(10.1866 25.6718 54.4551)",
    fill: "#24FDF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_10517_2866)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.6718,
    cy: 54.4551,
    r: 7.31214,
    transform: "rotate(10.1866 25.6718 54.4551)",
    fill: "#24FDF5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.672,
    cy: 54.4552,
    r: 6.15759,
    transform: "rotate(10.1866 25.672 54.4552)",
    fill: "#E9FCFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10517_2866)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.672,
    cy: 54.4552,
    r: 6.15759,
    transform: "rotate(10.1866 25.672 54.4552)",
    fill: "#E9FCFF"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.42092,
    cy: 3.42092,
    r: 3.42092,
    transform: "matrix(-0.999912 -0.0132435 -0.0132435 0.999912 29.072 49.5295)",
    fill: "url(#paint17_angular_10517_2866)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.42092,
    cy: 3.42092,
    r: 3.42092,
    transform: "matrix(-0.999912 -0.0132436 -0.0132436 0.999912 29.0269 52.9502)",
    fill: "url(#paint18_angular_10517_2866)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.936 18.8873C20.6024 19.3368 10.8915 21.5671 7.23868 34.8155C6.36556 37.9822 5.53785 46.8202 7.78451 54.6271L7.45708 53.8443C5.01016 46.2259 5.66499 39.0154 6.50593 35.6287C9.04811 22.0612 20.2133 18.8235 25.4781 18.9006C25.6309 18.8945 25.7836 18.89 25.936 18.8873Z",
    fill: "url(#paint19_linear_10517_2866)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2831 68.9363C21.0585 72.4052 18.6999 71.8294 17.6875 71.0001C16.7688 70.2476 15.9168 69.4605 15.1271 68.645C14.9142 68.4203 14.7109 68.1997 14.4888 67.9541C14.5383 67.9926 14.5896 68.0326 14.6425 68.0739C16.7542 69.7213 21.4764 73.4054 21.7844 65.8875C19.0898 64.9254 17.0275 63.7815 14.8084 60.4632C18.5412 64.3512 27.1987 68.0334 37.3194 59.9463C36.2129 61.2681 33.1311 64.2508 29.6549 65.6073C29.6349 68.8622 31.2938 73.8867 37.1562 67.9541L36.3488 68.8703C33.6208 71.6538 31.5643 72.1945 30.5329 72.0091C28.4496 71.6348 27.851 66.9871 27.6851 65.3716C26.3786 66.1143 23.8059 65.8041 23.0327 65.5131L23.0303 65.5263C23.0278 65.5254 23.0253 65.5244 23.0228 65.5235L22.7165 67.228C22.592 67.8806 22.4463 68.447 22.2831 68.9363Z",
    fill: "url(#paint20_linear_10517_2866)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.6976 59.4514C5.38203 50.1547 6.50238 39.2773 7.69796 34.8C7.09901 38.1333 7.86361 42.8238 7.9938 44.7588C9.75825 41.3221 10.9622 46.8562 11.3437 50.0529C12.9559 57.3287 17.3016 62.5932 24.246 63.841C20.8561 64.2094 16.8232 61.5079 15.3742 59.9007C12.8746 57.1284 9.79799 57.2044 10.6976 59.4514Z",
    fill: "#17D2B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.3324 41.3084C45.5694 32.9378 41.142 25.8794 38.8174 24.8167C40.6098 26.3685 40.8694 28.6068 40.6368 29.0951C39.5913 36.7214 41.0998 37.554 41.9848 37.0171C44.1075 34.9009 45.101 38.9962 45.3324 41.3084Z",
    fill: "#B3FF96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9937 42.6608C23.017 43.0954 25.7316 43.6545 28.4038 42.4143C27.3337 43.769 24.5536 45.715 21.9937 42.6608Z",
    fill: "#0E67A5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0343 7.47318C13.4982 9.00607 13.1394 12.5259 15.9933 14.3421C14.3725 13.8119 11.7115 11.6958 14.0343 7.47318Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1646 23.2482C16.4745 22.8583 17.3343 22.0965 18.2941 22.1684C17.7442 21.9085 16.5485 21.7605 16.1646 23.2482Z",
    fill: "#DFFE7D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1697 23.4833C30.4796 23.0934 31.3394 22.3316 32.2992 22.4036C31.7493 22.1436 30.5536 21.9956 30.1697 23.4833Z",
    fill: "#DFFE7D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3392 42.3078C25.5319 42.3511 27.0335 42.0437 28.0066 41.3853C27.9685 42.2888 26.821 42.9848 25.3392 42.3078Z",
    fill: "#68F88D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9128 25.2578C23.4827 25.9776 24.4185 28.3831 23.6027 32.2462C24.1326 30.7166 24.7364 27.1774 22.9128 25.2578Z",
    fill: "#E0FF7D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10517_2866",
    x: 11.6622,
    y: 40.4456,
    width: 28.0191,
    height: 28.0191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3481,
    result: "effect1_foregroundBlur_10517_2866"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10517_2866",
    x: 6.90882,
    y: 35.692,
    width: 37.5264,
    height: 37.5264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.30231,
    result: "effect1_foregroundBlur_10517_2866"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10517_2866",
    x1: 45.8313,
    y1: 51.4276,
    x2: 52.6696,
    y2: 56.8924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10517_2866",
    x1: 45.8316,
    y1: 51.4276,
    x2: 52.6699,
    y2: 56.8924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10517_2866",
    x1: 6.48459,
    y1: 51.4276,
    x2: -0.353724,
    y2: 56.8924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10517_2866",
    x1: 13.4815,
    y1: 12.7695,
    x2: 37.9596,
    y2: 12.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6CAFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10517_2866",
    x1: 35.0552,
    y1: 2.96073,
    x2: 16.2562,
    y2: 11.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10517_2866",
    x1: 25.9188,
    y1: 16.3569,
    x2: 26.0973,
    y2: 18.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2076E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10517_2866",
    x1: 24.4992,
    y1: 26.8715,
    x2: 26.1665,
    y2: 71.2693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88DA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227766,
    stopColor: "#2DCC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527866,
    stopColor: "#09BEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751875,
    stopColor: "#14BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0456DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10517_2866",
    x1: 18.6034,
    y1: 22.9485,
    x2: 18.6034,
    y2: 30.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BCE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10517_2866",
    x1: 33.0804,
    y1: 23.5192,
    x2: 33.0804,
    y2: 31.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BCE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10517_2866",
    x1: 18.6546,
    y1: 33.1532,
    x2: 18.6546,
    y2: 26.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10517_2866",
    x1: 33.0411,
    y1: 33.6196,
    x2: 33.0411,
    y2: 26.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10517_2866",
    x1: 18.6061,
    y1: 34.0483,
    x2: 19.5624,
    y2: 27.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10517_2866",
    x1: 18.6061,
    y1: 34.0483,
    x2: 19.5624,
    y2: 27.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10517_2866",
    x1: 30.8991,
    y1: 34.3627,
    x2: 31.8553,
    y2: 27.7428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10517_2866",
    x1: 25.4043,
    y1: 37.7895,
    x2: 25.5565,
    y2: 41.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12184C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0474BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10517_2866",
    x1: 30.9623,
    y1: 23.0062,
    x2: 33.939,
    y2: 24.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02555E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10517_2866",
    x1: 16.8052,
    y1: 23.7051,
    x2: 20.2027,
    y2: 24.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02555E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_angular_10517_2866",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.42092 3.42092) rotate(180) scale(2.15491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A5EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_10517_2866",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.42092 3.42092) scale(3.42092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20FEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24FFFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10517_2866",
    x1: 24.0405,
    y1: 20.0109,
    x2: 5.06094,
    y2: 49.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#94FD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FE8A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10517_2866",
    x1: 23.2033,
    y1: 58.7132,
    x2: 22.6235,
    y2: 70.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003982"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhereAmIButton);
export default __webpack_public_path__ + "static/media/where-am-i-button.7a375d7dc83d12a72195b7aa1b5d79ef.svg";
export { ForwardRef as ReactComponent };